var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoHome = function SvgIcoHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "m20 12.414.293.293a1 1 0 0 0 1.414-1.414L19.994 9.58A1 1 0 0 0 20 9.5v-5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1.086l-3.293-3.293a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 1 0 1.414 1.414L4 12.414V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoHome;